import React from 'react';
import './../../App.css'
import './pagetitle.css'
import { MdArrowForwardIos } from "react-icons/md"
import rotateicon1 from './../../Images/banner.png'
import rotateicon2 from './../../Images/download (3).png'
import rotateicon3 from './../../Images/download (4).png'
export default function Pagetitle(props) {
  return (
    <div className='page-title-area'>
      <div className="container">
        <div className="page_title_innerdiv">
            <h2>{props.pagename}</h2>
            <ul>
                      <li>
                          <a href="/">{props.parentpage} <MdArrowForwardIos/></a> 
                      </li>
                      <li>{props.pagename}</li>
            </ul>
        </div>
      </div>
      <div className="pagetitlebox-img1">
              <img src={rotateicon1}/>
      </div>
      <div className="pagetitlebox-img2">
              <img src={rotateicon2} />
      </div>
      <div className="pagetitlebox-img3">
              <img src={rotateicon3} />
      </div>
    </div>
  )
}
